export class GlobeContext {
  constructor(public canvas: HTMLCanvasElement) {}
}
